import { settings } from '../settings'

export default {
  root: {
    color: `${settings.theme.palette.info.dark}`,
    width: '100%',
  },
}
